import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisViewDetailChartData, StatisticalAnalysisViewDetailChartFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.model'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisActivityTypes, StatisticalAnalysisEnumsAndKeys } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import i18n from '@/lang/i18n'
import { Options } from 'highcharts'
import { StatisticalAnalysisActivityDossierExternalInfo } from '@/modules/statistical-analysis-module/views/service-activity-dossier/service-activity-dossier.model'
import { StatisticalAnalysisActivityStatisticsDossierBaseRequest, StatisticalAnalysisActivityStatisticsDossierGroupRequest, StatisticalAnalysisActivityStatisticsDossierGroupRequestEnum } from '@/modules/statistical-analysis-module/services/activity-dossier/activity-dossier.dto'
import { activityStatisticsDossierService } from '@/modules/statistical-analysis-module/services/activity-dossier/activity-dossier.service'

export class StatisticalAnalysisHandlerChartActivityDossier {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>) {
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
    }

    public async getChart(): Promise<Options> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisActivityDossierExternalInfo
        const baseRequest: StatisticalAnalysisActivityStatisticsDossierBaseRequest = activityStatisticsDossierService.getBaseRequest(sidebarFilter)
        const groupRequest: StatisticalAnalysisActivityStatisticsDossierGroupRequest = {
            groupBy1: this.statisticalAnalysisFilters?.xAxis.groupBy1 as StatisticalAnalysisActivityStatisticsDossierGroupRequestEnum,
            groupBy2: this.statisticalAnalysisFilters?.xAxis.groupBy2 as StatisticalAnalysisActivityStatisticsDossierGroupRequestEnum
        }
        const yAxis: StatisticalAnalysisActivityTypes = this.statisticalAnalysisFilters?.yAxis as StatisticalAnalysisActivityTypes
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        const response: StatisticalAnalysisViewDetailChartData = await activityStatisticsDossierService.getDetailViewChart(typeCase, baseRequest, groupRequest, yAxis)
        let titleYAxis: string = ''
        switch (yAxis) {
        case StatisticalAnalysisActivityTypes.TOTAL:
            titleYAxis = StatisticalAnalysisEnumsAndKeys.ACTIVITY_TOTAL.getText()
            break
        case StatisticalAnalysisActivityTypes.URV:
            titleYAxis = StatisticalAnalysisEnumsAndKeys.URV.getText()
            break
        case StatisticalAnalysisActivityTypes.UCL:
            titleYAxis = StatisticalAnalysisEnumsAndKeys.UCL.getText()
            break
        default:
            titleYAxis = StatisticalAnalysisEnumsAndKeys.ACTIVITY_TOTAL.getText()
        }
        return {
            xAxis: {
                categories: response.categories
            },
            yAxis: {
                title: {
                    text: `${i18n.tc(titleYAxis)}`
                }
            },
            series: response.series
        }
    }
}
